import {z} from '@hono/zod-openapi';

/**
 * The report or request id in the path. Not `.openapi`-named on purpose: `@hono/zod-openapi`
 * expands a params object into individual `parameters`, so a component name would only add an
 * unreferenced entry to the shared document. The same holds for every request-side schema here.
 */
export const priceReportIdParamSchema = z.object({id: z.string()});
